import axiosWrap from './axios'
import logError from './logger'

export const getLegal = () => {
  return axiosWrap({ url: '/legal', method: 'GET' })
    .then(({ data }) => data)
    .catch('ERROR GETLEGAL AXIOS CALL', logError)
}
